<template lang="pug">
  el-button.filter-by-type-button(type="text", size="mini")
    el-dropdown(trigger="click", @command="setSortActive", :title="$t('Filter by media type')")
      el-button(
        size="mini",
        type="text",
        :class='{ active: activeType.length}'
      )
        font-awesome-icon(icon="sort-amount-down", class="left-menu-dropdown-icon", :class='{ muted: !activeType.length}')
        span.type-name(v-if='activeType.length') {{ $t(options.find(opt => opt.command === activeType).displayName) }}
      el-dropdown-menu(slot='dropdown')
        el-dropdown-item(
          v-for='option of options',
          :key='option.command',
          :command='option.command',
          :class='{ active: activeType === option.command}',
          :id="'SortButton-option' + option.command"
        )
          font-awesome-icon.icon(:icon="option.icon")
          span &nbsp; &nbsp; {{$t(option.displayName)}}
    i.el-icon-error.type-name(v-if="activeType.length", @click="setSortActive('Name'); activeType = ''")
</template>

<script>

export default {
  props: ['side'],
  data () {
    return {
      activeType: '',
      options: [
        { command: 'Name', displayName: 'Name', icon: 'text-height' },
        { command: 'Duration', displayName: 'Duration', icon: 'stopwatch' },
        { command: 'updatedAt', displayName: 'Modified', icon: 'save' },
        { command: 'createdAt', displayName: 'Created', icon: 'folder-plus' }
      ]
    }
  },
  methods: {
    setSortActive (type) {
      this.activeType = type
      this.$emit('setMediaSortActive', type)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.filter-by-type-button {
  padding: 0px;
  margin: 0px 0px 0px 5px;
  .active {
    color: $--color-warning;
  }
  .type-name {
    color: $--color-text-secondary;
    margin-left: 5px;
  }
}
.icon {
  width: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/SortButton.vue